// extracted by mini-css-extract-plugin
export default {"draggableRow":"CollectionsAdmin_draggableRow__4UbMa","dragging":"CollectionsAdmin_dragging__bKJnZ","dragHandle":"CollectionsAdmin_dragHandle__k-Ngj"};